import React from 'react';

const EQReturnStatus = ({Title, DueDate}) => {
    return(
        <div className="padding-right-tiny">
            <h4 className="margin-top-zero red_font title">{Title}</h4>
            <div className="margin-bottom-tiny">
                <p className="margin-bottom-tiny">Please return the following Verizon equipment before <b>{DueDate}</b> to avoid unreturned equipment charges. Your Fios Return Kit is on its way.&nbsp;</p>
            </div>
        </div>
    )
}

export default EQReturnStatus


// WEBPACK FOOTER //
// ./src/components/modules/EQReturnStatus.js